import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { AuthLayout } from "@/components/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, Eye, EyeOff } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Accesso effettuato");
      navigate(u.role === "super_admin" ? "/admin" : "/dashboard");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  const fill = (em) => { setEmail(em); setPassword(em.includes("admin@connectivity") ? "Admin2025!" : "Connectivity2025!"); };

  return (
    <AuthLayout title="Bentornato" subtitle="Accedi al tuo account Connectivity">
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="nome@azienda.it" data-testid="login-email" />
        </div>
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Label htmlFor="password">Password</Label>
            <Link to="/forgot-password" className="text-xs text-primary hover:underline" data-testid="forgot-link">
              Password dimenticata?
            </Link>
          </div>
          <div className="relative">
            <Input id="password" type={show ? "text" : "password"} required value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="login-password" />
            <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground">
              {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
          </div>
        </div>
        <Button type="submit" className="w-full rounded-lg" disabled={loading} data-testid="login-submit">
          {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Accedi
        </Button>
      </form>

      <div className="mt-6 rounded-xl border border-dashed border-border bg-muted/40 p-4 text-xs">
        <p className="mb-2 font-medium text-foreground">Account demo</p>
        <div className="flex flex-wrap gap-2">
          <button onClick={() => fill("owner@lamaisonette.demo")} className="rounded-md border border-border bg-background px-2.5 py-1 hover:border-primary" data-testid="demo-owner">Owner (La Maisonette)</button>
          <button onClick={() => fill("admin@connectivity.io")} className="rounded-md border border-border bg-background px-2.5 py-1 hover:border-primary" data-testid="demo-superadmin">Super Admin</button>
        </div>
      </div>

      <p className="mt-6 text-center text-sm text-muted-foreground">
        Non hai un account?{" "}
        <Link to="/register" className="font-medium text-primary hover:underline" data-testid="register-link">Registrati</Link>
      </p>
    </AuthLayout>
  );
}
